import {
	ORDER_DATES_FAILURE,
	ORDER_DATES_SUCCESS,
	ORDER_TIME_SLOTS_FAILURE,
	ORDER_TIME_SLOTS_REQUEST,
	ORDER_TIME_SLOTS_SUCCESS,
	SEND_ORDER,
	SEND_ORDER_SUCCESS,
} from 'new-constants/api.constants';
import { AsapMarker } from 'new-constants/common.constants';
import { SET_PICKUP_DATE_TIME } from 'new-constants/order-time.constants';
import { STRIPE_SUCCESS, VIPPS_SUCCESS } from 'new-constants/payment.constants';
import { DONE_INCOMPATIBLE_CART_CONFIRMATION } from 'new-constants/popup.constants';
import { OrderTimeState } from './order-time.reducer.types';
import { CHECK_ADYEN_PAYMENT_SUCCESS, CHECK_PAYMENT_STATUS_SUCCESS, ORDER_SUCCESS } from '../constants/api.constants';
import { PaymentStatuses } from "../constants/common.constants";
import { ADYEN_SUCCESS } from '../constants/payment.constants';

const initialState: OrderTimeState = {
	asap: null,
	dates: [],
	timeSlotDate: null,
	timeSlots: [],
	todayDate: null,
	pickupDate: null,
	pickupTime: null,
	restaurantId: null,
};

export const orderTimeReducer = (previousState = initialState, action): OrderTimeState => {
	switch (action && action.type) {
		case ORDER_DATES_SUCCESS: {
			let nextPickupDate = previousState.pickupDate;
			let nextPickupTime = previousState.pickupTime;

			let newTimeSlots = action.payload.timeSlots || [];
			if (action.payload.asap) {
				newTimeSlots = [AsapMarker, ...action.payload.timeSlots];
			}

			if (!previousState.pickupDate && !previousState.pickupTime) {
				nextPickupDate = action.payload.timeSlotDate;
				nextPickupTime = action.payload.asap ? AsapMarker : null;
			} else if (!action.payload.dates.includes(previousState.pickupDate)) {
				nextPickupDate = null;
				nextPickupTime = null;
			} else if (
				action.payload.timeSlotDate === previousState.pickupDate &&
				!newTimeSlots.includes(previousState.pickupTime)
			) {
				nextPickupTime = null;
			}

			return {
				...previousState,
				asap: action.payload.asap,
				dates: action.payload.dates,
				timeSlotDate: action.payload.timeSlotDate,
				timeSlots: newTimeSlots,
				todayDate: action.payload.todayDate,
				pickupDate: nextPickupDate,
				pickupTime: nextPickupTime,
				restaurantId: action.payload.restaurantId,
			};
		}
			break;

		case ORDER_DATES_FAILURE:
			return {
				...previousState,
				asap: null,
				dates: [],
				timeSlotDate: null,
				timeSlots: [],
				todayDate: null,
				pickupDate: null,
				pickupTime: null,
			};
			break;

		case ORDER_TIME_SLOTS_REQUEST:
			return {
				...previousState,
				timeSlots: [],
				timeSlotDate: null,
			};
			break;

		case ORDER_TIME_SLOTS_SUCCESS: {
			let nextPickupTime = previousState.pickupTime;

			let newTimeSlots = action.payload.timeSlots || [];
			if (action.payload.asap) {
				newTimeSlots = [AsapMarker, ...action.payload.timeSlots];
			}

			if (
				action.payload.timeSlotDate === previousState.pickupDate &&
				!previousState.pickupTime &&
				newTimeSlots.length > 0
			) {
				nextPickupTime = newTimeSlots[0];
			} else if (
				action.payload.timeSlotDate === previousState.pickupDate &&
				!newTimeSlots.includes(previousState.pickupTime)
			) {
				nextPickupTime = null;
			}
			return {
				...previousState,
				asap: action.payload.asap,
				timeSlotDate: action.payload.timeSlotDate,
				timeSlots: newTimeSlots,
				todayDate: action.payload.todayDate,
				pickupTime:
					action.payload.timeSlotDate === previousState.pickupDate && !newTimeSlots.includes(previousState.pickupTime)
						? null
						: previousState.pickupTime,
			};
		}
			break;

		case ORDER_TIME_SLOTS_FAILURE:
			return {
				...previousState,
				timeSlotDate: null,
				timeSlots: [],
				pickupTime: null,
			};
			break;

		case SET_PICKUP_DATE_TIME:
			return {
				...previousState,
				pickupDate: action.date,
				pickupTime: action.time,
			};
			break;

		case SEND_ORDER_SUCCESS:
			if (action.payload.isOrderSent) {
				return {
					...previousState,
					pickupDate: null,
					pickupTime: null,
                    timeSlots: []
				};
			}

			return previousState;
			break;

		case STRIPE_SUCCESS:
		case VIPPS_SUCCESS:
			return {
				...previousState,
				pickupDate: null,
				pickupTime: null,
			};
			break;

		case ADYEN_SUCCESS:
			if (action.payload.action.type === 'redirect' || action.payload.action.type === 'threeDS2' || action.payload.action.type === 'swish') {
				return {
					...previousState,
				}
			}
			return {
				...previousState,
				pickupDate: null,
				pickupTime: null,
			};
			break;


		case CHECK_PAYMENT_STATUS_SUCCESS:
			if (!(action.payload.isAdyenOrder && action.payload.data.status === PaymentStatuses.complete)) {
				return previousState;
			}

			return {
				...previousState,
				pickupDate: null,
				pickupTime: null,
			};
			break;

		case CHECK_ADYEN_PAYMENT_SUCCESS:
			if (action.payload.data.resultCode !== PaymentStatuses.authorised) {
				return previousState;
			}

			return {
				...previousState,
				pickupDate: null,
				pickupTime: null,
			};
			break;

		case ORDER_SUCCESS:
			if (!(action.payload.isScheduledForCancel && action.payload.data.order.isPaid)) {
				return previousState;
			}

			return {
				...previousState,
				pickupDate: null,
				pickupTime: null,
			};
			break;

		case DONE_INCOMPATIBLE_CART_CONFIRMATION:
			return {
				...previousState,
				pickupDate: null,
				pickupTime: null,
			};
			break;

		default:
			return previousState;
	}
};
